import { Link } from "react-router-dom";
import PageHeader from "../../components/layout/PageHeader";

export default function Register() {
  return (
    <>
      <PageHeader title="Register" crumbs={[{ label: "Register" }]} />
      <section className="section">
        <div className="container">
          <div className="auth-wrap">
            <h2>Create Account</h2>
            <p className="sub">Join Taxi24hrs today</p>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="field">
                  <label>First Name</label>
                  <input type="text" required />
                </div>
                <div className="field">
                  <label>Last Name</label>
                  <input type="text" required />
                </div>
              </div>
              <div className="field">
                <label>Email Address</label>
                <input type="email" placeholder="you@example.com" required />
              </div>
              <div className="field">
                <label>Password</label>
                <input type="password" placeholder="••••••••" required />
              </div>
              <div className="field">
                <label>Confirm Password</label>
                <input type="password" placeholder="••••••••" required />
              </div>
              <div className="form-meta">
                <label><input type="checkbox" required /> I agree to the Terms & Conditions</label>
              </div>
              <button type="submit" className="btn btn-primary btn-block">Create Account</button>
            </form>
            <p className="auth-alt">
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
